import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCurrentUser, logoutUser } from "../redux/features/AuthSlice";

const AppInitializer = ({ children }) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    if (token) {
      dispatch(fetchCurrentUser())
        .unwrap()
        .catch(() => {
          dispatch(logoutUser());
        });
    }
  }, [dispatch, token]);

  return children;
};

export default AppInitializer;
